import "./FormConfigBadges.scss";
import React, { useContext } from "react";
import { Icon, Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import { formsContext } from "../../../../../contexts";

const FormConfigBadges = ({ mode, record, risks, riskConditionKey, relatedRecord }) => {
  const { t } = useTranslation(['forms', 'translations']);
  const { templateVersion } = useContext(formsContext) || {};

  if(mode !== 'preview') return null;

  const recordField = record?.field;
  const personType = templateVersion?.template?.tipoPersona;
  const recordLabels = relatedRecord
    ? {
        tipoDoc: ['messages.aml.dniType'],
        dni: ['messages.aml.dniLarge'],
        name: ['messages.aml.name'],
        type: ['messages.aml.entityRelation'],
        email: ['messages.aml.email'],
        citizenship: ['messages.aml.nationality'],
        dateBirth: ['messages.aml.birthDate'],
        residentOf: ['messages.aml.residenceCountry']
      }
    : {
        profesion: personType === 'ALL'
          ? ['messages.aml.title.profession', 'messages.aml.title.comercialActivity']
          : [personType === 'Person' ? 'messages.aml.title.profession' : 'messages.aml.title.comercialActivity'],
        nacionalidad: personType === 'ALL'
          ? ['messages.aml.nationality', 'messages.aml.countryofregister']
          : [personType === 'Person' ? 'messages.aml.nationality' : 'messages.aml.countryofregister'],
        fecNac: personType === 'ALL'
          ? ['messages.aml.birthDate', 'messages.aml.registerDate']
          : [personType === 'Person' ? 'messages.aml.birthDate' : 'messages.aml.registerDate'],
        pais: ['messages.aml.countryofresindent'],
        proposito: ['messages.aml.title.purpose'],
        alias: personType === 'ALL'
          ? ['messages.aml.title.alias.Person', 'messages.aml.title.alias.Entity']
          : [personType === 'Person' ? 'messages.aml.title.alias.Person' : 'messages.aml.title.alias.Entity'],
        celular: ['messages.aml.title.cellphone'],
        telefono: ['messages.aml.title.phone'],
        contacto: ['messages.aml.name'],
        cargo: ['messages.aml.position'],
        paisDir: ['messages.aml.country'],
        region: ['messages.aml.region'],
        comuna: ['messages.aml.neighbourhood'],
        direccion: ['messages.aml.address'],
        paisTributaria: ['messages.aml.tax.country'],
        direccionTributaria: ['messages.aml.tax.address.complete']
      };

  const recordLabelKeys = recordLabels[recordField];
  const recordLabel = recordLabelKeys
    ? recordLabelKeys.map(key => t(key, {ns: 'translations'})).join(' / ')
    : recordField;
  const riskConfigs = Array.isArray(risks)
    ? risks.filter(item => item && typeof item.risk === 'string' && item.risk.length > 0)
    : [];
  const riskTitle = t('messages.aml.cdi.dashboard.riesgo', {ns: 'translations'});

  if(!recordLabel && riskConfigs.length === 0) return null;

  return (
    <span className="form-config-badges">
      {recordLabel &&
        <Tooltip title={`${t('messages.aml.register', {ns: 'translations'})}: ${recordLabel}`} placement="top">
          <Tag color="blue"><Icon type="idcard" /> {t('messages.aml.register', {ns: 'translations'})}</Tag>
        </Tooltip>
      }
      {riskConfigs.length > 0 &&
        <Tooltip
          title={
            <div>
              <div>{riskTitle}:</div>
              {riskConfigs.map((item, index) => {
                const riskLabel = t(`messages.aml.titles.${item.risk}`, {ns: 'translations'});
                let condition = '';
                if(typeof item[riskConditionKey] === 'boolean') {
                  if(riskConditionKey === 'checked') {
                    condition = ` (Checkbox: ${item.checked ? 'Marcado' : 'Desmarcado'})`;
                  }else if(riskConditionKey === 'decision') {
                    condition = ` (Decisión: ${item.decision ? t('forms.options.si') : t('forms.options.no')})`;
                  }
                }
                return <div key={`${item.risk}-${index}`}>{riskLabel}{condition}</div>;
              })}
            </div>
          }
          placement="top"
        >
          <Tag color="purple"><Icon type="safety" /> {riskTitle}</Tag>
        </Tooltip>
      }
    </span>
  );
};

export default FormConfigBadges;
